export default {
  props: {
    title: String,
    color: String,
    icon: String,
  },
};
